const get = require('lodash/get')
const tools = require('../../tools')
const { time, log } = require('../../tools/logging')

const { decorateSuborder } = require('./decorate-suborder')

exports.getSuborder = getSuborder
async function getSuborder (
  state,
  {suborderId, alias = 'one', date = new Date().toJSON(), logging = false, useGenericParent = false, raw = false},
  {unfiltered = false} = {}
) {
  const timeOrder = time()
  const doc = await state.dal.order.getSuborder(state, {suborderId})
  log('got order', logging, timeOrder)

  if (!doc) {
    const err = new Error(`No accepted suborder with id "${suborderId}" found.`)
    err.status = 404
    throw err
  }

  if (!unfiltered) {
    if (!get(state, 'user.programs', []).includes(doc.programId)) {
      const err = new Error(`User does not have access to program "${doc.programId}"`)
      err.status = 403
      throw err
    }
  }

  if (raw) return doc

  return decorateSuborder(state, doc, {alias, date, useGenericParent, logging})
}

exports.getOrder = getOrder
async function getOrder (state, {orderId, withSnapshots = false, useAcceptedStatus = false}) {
  tools.validateParams('get', arguments[1])
  const locationId = state.user.location.id
  const snapshots = await state.dal.order.get(state, {orderId})
  // `updatedAt` is sometimes the number of ms since epoch
  for (const s of snapshots) {
    if (typeof s.updatedAt === 'number') {
      s.updatedAt = new Date(s.updatedAt).toJSON()
    }
  }
  const status = tools.getUserStatus(state.user)
  if (snapshots.length === 0) {
    return null
  }
  return tools.docsToOrderEntity({docs: snapshots, withSnapshots, locationId, status, useAcceptedStatus})
}

exports.getGroup = getGroup
async function getGroup (state, {groupId, useAcceptedStatus = false, withSnapshots = false}) {
  tools.validateParams('getGroup', arguments[1])
  const snapshots = await state.dal.order.getGroup(state, {groupId, useAcceptedStatus})
  const status = tools.getUserStatus(state.user)
  const locationId = state.user.location.id
  const orders = tools.docsToOrderEntities({
    docs: snapshots, withSnapshots, status, locationId, useAcceptedStatus
  })
  // TODO: next two lines can be merged into a tools.getGroupInfo
  const programId = orders.length ? orders[0].programId : null
  const {status: groupStatus, statusDisplayName, isComplete, orderType} = tools.getGroupStatus(orders)
  return {orders, status: groupStatus, statusDisplayName, programId, isComplete, orderType}
}

exports.getOrderFromLocationId = getOrderFromLocationId
async function getOrderFromLocationId (state, { groupId, locationId }) {
  if (!groupId || !locationId) {
    throw Error('Missing required parameters')
  }
  const snapshots = await state.dal.order.getGroup(state, {groupId})
  return snapshots.filter(order => order.destinationId === locationId)
}

exports.getShipmentsOnOrder = getShipmentsOnOrder
async function getShipmentsOnOrder (state, orderId) {
  const shipments = await state.dal.order.getShipmentsOnOrder(state, orderId)
  return shipments
}
